
import React from 'react'
import styles from './ProfileImage.scss'
import { ImageField } from '../jbc-front/components/Form'

export const BranchProfileImage = ({name, label, image, uploadImage, aspect, defaultImage, removeImage}) => {
    return(
        <div className={`${styles.imageuploadcontainer} ${uploadImage !== null && styles.edit}`}>
            <div className={styles.label}>
                {label &&
                    <p>{label}</p>
                }
            </div>
            <div className={`${styles.image} ${uploadImage !== null && styles.edit}`}>
                {image ? <img src={`${image}`}/> : defaultImage }
            </div>
            {uploadImage && <ImageField name={name} uploadImage={uploadImage} aspect={aspect} removeImage={removeImage} /> }
            
        </div>
    )
}